/**
 * Базовые SEO-настройки сайта (домен и аналитика — из env при деплое).
 */

const DEFAULT_SITE_URL = 'https://welland-create.kz';

/**
 * Публичный origin без завершающего слэша.
 * @returns {string}
 */
export function getSiteUrl() {
    const raw = String(process.env.REACT_APP_SITE_URL || DEFAULT_SITE_URL).trim();
    return raw.replace(/\/+$/, '') || DEFAULT_SITE_URL;
}

export const SITE_CONFIG = {
    siteName: 'Welland',
    productName: 'Welland Create',
    defaultLocale: 'ru_KZ',
    defaultLanguage: 'ru',
    contact: {
        phone: '+7 777 229 62 25',
        email: 'info@welland.kz',
        region: 'Казахстан',
    },
    social: {
        instagram: 'https://www.instagram.com/welland.kz',
        whatsapp: 'https://wa.me/77772296225',
    },
};

/**
 * Абсолютный URL ресурса на сайте.
 * @param {string} pathname
 * @returns {string}
 */
export function absoluteUrl(pathname = '/') {
    const base = getSiteUrl();
    if (!pathname || pathname === '/') {
        return `${base}/`;
    }
    const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
    return `${base}${path}`;
}

/** OG/Twitter: обложка 1200×630 для шаринга в соцсетях. */
export const DEFAULT_OG_IMAGE_PATH = '/og-cover.png';

/**
 * @param {string} [path]
 * @returns {string}
 */
export function getDefaultOgImageUrl(path = DEFAULT_OG_IMAGE_PATH) {
    return absoluteUrl(path);
}

/**
 * ID счётчиков — подставляются при запуске (см. .env.example).
 * @returns {{ ga4: string|null, yandexMetrika: string|null }}
 */
export function getAnalyticsIds() {
    const ga4 = String(process.env.REACT_APP_GA4_MEASUREMENT_ID || '').trim();
    const yandexMetrika = String(process.env.REACT_APP_YANDEX_METRIKA_ID || '').trim();
    return {
        ga4: ga4 || null,
        yandexMetrika: yandexMetrika || null,
    };
}

/**
 * Включать ли внешние скрипты аналитики (только production + задан ID).
 * @returns {boolean}
 */
export function isAnalyticsEnabled() {
    if (process.env.NODE_ENV !== 'production') {
        return false;
    }
    const { ga4, yandexMetrika } = getAnalyticsIds();
    return Boolean(ga4 || yandexMetrika);
}
